module.exports = __webpack_public_path__ + "img/Freespin_l4.2ca61153.png";